import { render, staticRenderFns } from "./offer-configuration-rate-table.vue?vue&type=template&id=839480a0&"
import script from "./offer-configuration-rate-table.vue?vue&type=script&lang=js&"
export * from "./offer-configuration-rate-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports